import { atom } from "recoil";

const defaultThemeName = `${process.env.REACT_APP_THEME_NAME}`;

export const cursorThemeNameState = atom<string>({
  key: "CursorThemeState",
  default: defaultThemeName,
});
